

























































import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { Form, Button, Input, Option, Select } from 'element-ui';
import ModalCard from '@/components/layout/ModalCard.vue';

import upsertBillItemTemplate from '@/graphql/mutations/BillItemTemplate/Upsert.gql';

import { TaxTypeEnum, BillItemFields } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    ModalCard,
    'el-button': Button,
    'el-form': Form,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class billItemTemplateUpsert extends Vue {
  @Prop({ default: null, type: [String, null as any] }) itemTemplateName!: string | null;
  @Prop({ default: false, type: Boolean }) open?: boolean;
  @Prop() billItem!: BillItemFields;

  billItemTemplate = {
    taxType: this.billItem.taxType,
    description: this.billItem.description,
    category: this.billItem.category
  };

  isLoading = false;

  async createItem() {
    this.isLoading = true;
    try {
      const response = await this.$apollo.mutate({
        mutation: upsertBillItemTemplate,
        variables: {
          biItemTemplateArgs: {
            description: this.itemTemplateName,
            taxType: this.billItemTemplate.taxType,
            category: this.billItemTemplate.category
          }
        }
      });

      if (response) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
        this.$emit('createItem', response.data?.upsertBillItemTemplate);
        this.$emit('close');
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.isLoading = false;
    }
  }
}
